const calculatePercentOKR = (target: number, initialValue: number, realizedValues: number) => {
	let percent = 0;
	if (target !== 0)
	{
		if (target - initialValue === 0)
			percent = ((realizedValues + initialValue) / target) * 100;
		else
			percent = (realizedValues / (target - initialValue)) * 100;
	}
    
	return percent;
};

export default calculatePercentOKR;

        
        
